import React, { useState, useContext } from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames/bind';

import FieldSearchManu from './components/FieldSearchManu';
import FieldSearchModel from './components/FieldSearchModel';
import FieldSearchCarType from './components/FieldSearchCarType';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import { SearchContext } from 'context/SearchContext';
import { StaticTextContext } from 'context/StaticTextContext';

import styles from './CarIncrementalSearch.module.scss';
const cx = classNames.bind(styles);

const CarIncrementalSearch = ({
  updatePartData,
  updatePartValue,
  isCarPlateSearch,
  pageType,
}) => {
  const [modelInputValue, setModelInputValue] = useState('');
  const [carInputValue, setCarInputValue] = useState('');
  const [dataModels, setDataModels] = useState([]);
  const [dataCarTypes, setDataCarTypes] = useState([]);

  const { labels } = useContext(StaticTextContext);
  const {
    isPartTooltip,
    isManuTooltip,
    isModelTooltip,
    isCarTooltip,
  } = useContext(SearchContext);

  const isTooltipOpen =
    isPartTooltip || isCarTooltip || isManuTooltip || isModelTooltip;

  return (
    <div
      className={cx(
        'car',
        { 'search-by-plate': isCarPlateSearch },
        {
          'opened-tooltip': isTooltipOpen,
        }
      )}
    >
      <label className={cx('label')}>{labels.searchCarLabel}</label>

      <div className={cx('form-control-flex')}>
        <FieldSearchManu
          className={cx('form-control-item')}
          pageType={pageType}
          setDataModels={setDataModels}
          updatePartValue={updatePartValue}
          setCarInputValue={setCarInputValue}
          setModelInputValue={setModelInputValue}
        />
        <FieldSearchModel
          className={cx('form-control-item')}
          pageType={pageType}
          dataModels={dataModels}
          isCarPlateSearch={isCarPlateSearch}
          modelInputValue={modelInputValue}
          setDataCarTypes={setDataCarTypes}
          setCarInputValue={setCarInputValue}
          setModelInputValue={setModelInputValue}
          updatePartValue={updatePartValue}
        />
        <FieldSearchCarType
          className={cx('form-control-item')}
          pageType={pageType}
          isCarPlateSearch={isCarPlateSearch}
          dataCarTypes={dataCarTypes}
          setCarInputValue={setCarInputValue}
          carInputValue={carInputValue}
          updatePartValue={updatePartValue}
          updatePartData={updatePartData}
        />
      </div>
    </div>
  );
};

CarIncrementalSearch.propTypes = {
  pageType: string.isRequired,
  isCarPlateSearch: bool.isRequired,
  updatePartValue: func.isRequired,
  updatePartData: func.isRequired,
};

export default withErrorBoundary(CarIncrementalSearch);



// WEBPACK FOOTER //
// ./src/components/CarIncrementalSearch/CarIncrementalSearch.js